import { Box, Image, SimpleGrid, Stack, Text, VStack } from "@chakra-ui/react";
import Logo from "../../../assets/colorLogo.png";

export const departmentOptions = [
  { value: 0, name: "National department" },
  { value: 1, name: "IG department" },
  { value: 2, name: "American department" },
  { value: 3, name: "College department" },
];

const Categories = ({ selectedDepartment, onSelectDepartment }) => {
  return (
    <VStack gap={6} h="100%" w="100%" alignItems="flex-start" my={20}>
      <Text
        fontSize="32px"
        color="main_2"
        textAlign="center"
        fontWeight="700"
        textTransform="uppercase"
        w="100%"
      >
        Parent category
      </Text>
      <SimpleGrid
        columns={{ base: 1, sm: 2, lg: 4 }}
        spacing={6}
        w="100%"
        px={{ base: 2, md: 0 }}
      >
        {departmentOptions.map((data) => {
          const isSelected = selectedDepartment === data.value;
          return (
            <Box
              key={data.value}
              bg={isSelected ? "main_1" : "blackAlpha.200"}
              color={isSelected ? "white" : "inherit"}
              padding={5}
              h="280px"
              borderRadius={16}
              alignItems="center"
              justifyContent="center"
              display="flex"
              flexDirection="column"
              role="group"
              cursor="pointer"
              border={isSelected ? "2px solid" : "2px solid transparent"}
              borderColor={isSelected ? "main_1" : "transparent"}
              boxShadow={isSelected ? "lg" : "none"}
              onClick={() =>
                onSelectDepartment(
                  selectedDepartment === data.value ? null : data.value
                )
              }
              _hover={{
                transform: "translateY(-5px)",
                transition: "300ms ease-in-out",
                boxShadow: "lg",
              }}
            >
              <Image
                src={Logo}
                alt={data.name}
                borderRadius="full"
                w="100px"
                h="100px"
                objectFit="contain"
                _groupHover={{
                  transform: "scale(1.1)",
                  transition: "500ms ease-in-out",
                }}
              />
              <Stack mt="4" spacing="3" textAlign="center">
                <Text fontWeight={isSelected ? "700" : "500"}>{data.name}</Text>
              </Stack>
            </Box>
          );
        })}
      </SimpleGrid>
    </VStack>
  );
};

export default Categories;
